import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule} from '@angular/forms';
import { MatFormField, MatLabel } from '@angular/material/select';
import { MatOption, MatSelect } from '@angular/material/select';
import { MatProgressBar } from '@angular/material/progress-bar';
import {MatCard, MatCardContent} from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import {MatInput, MatInputModule} from '@angular/material/input';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { NgApexchartsModule } from 'ng-apexcharts';
import {
  ApexAxisChartSeries,
  ApexChart,
  ApexXAxis,
  ApexDataLabels,
  ApexTitleSubtitle,
  ApexStroke,
  ApexGrid,
  ApexYAxis,
  ApexTooltip,
  ApexMarkers,
  ApexLegend
} from 'ng-apexcharts';
import { MunicipalityService } from '../../../core/services/municipality/municipality/municipality.service';
import { HealthUnitService } from '../../../core/services/health-unit/location/health-unit.service';
import { ResponseRequestModel } from '../../../core/models/response.model';
import {CommonModule, NgForOf, NgIf} from '@angular/common';
import { TableListComponent } from '../../../shared/components/table-list/table-list.component';
import {ContextService} from '../../../core/services/context/context.service';
import {MatButton, MatIconButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {MeasureService} from '../../../core/services/measure/measure.service';
import {MatChip, MatChipListbox, MatChipOption, MatChipRemove} from '@angular/material/chips';
import {SnackbarCustomService} from '../../../shared/components/snackbar/snackbar-custom.service';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {MatTooltip} from '@angular/material/tooltip';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  dataLabels: ApexDataLabels;
  grid: ApexGrid;
  stroke: ApexStroke;
  title: ApexTitleSubtitle;
  yaxis: ApexYAxis;
  tooltip: ApexTooltip;
  markers: ApexMarkers;
  legend: ApexLegend;
  colors: string[];
};

interface MedicaoData {
  id: string;
  data_medicao: string;
  hora_medicao: string;
  valor: string;
  contexto: string;
  paciente_id: string;
  paciente_nome: string;
  unidade_saude: string;
  municipio: string;
  unidade_de_medida: string;
}

@Component({
  selector: 'measure-report',
  imports: [
    ReactiveFormsModule,
    FormsModule,
    MatCard,
    MatSelect,
    MatOption,
    MatFormField,
    MatLabel,
    MatProgressBar,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    MatPaginatorModule,
    NgApexchartsModule,
    CommonModule,
    TableListComponent,
    MatCardContent,
    MatButton,
    MatChip,
    MatChipListbox,
    MatIcon,
    MatIconButton,
    MatIcon,
    MatChipListbox,
    MatChip,
    NgForOf,
    NgIf,
    MatInput,
    MatIconButton,
    MatProgressSpinner,
    MatTooltip,
  ],
  templateUrl: './measure-report.component.html',
  styleUrl: './measure-report.component.scss',
  standalone: true,
})
export class MeasureReportComponent implements OnInit {
  form!: FormGroup;
  loading: boolean = false;
  isSelectHealthUnitActive: boolean = false;
  municipiosList: any[] = [];
  unidadeSaudeList: any[] = [];
  contextosList: any[] = [];

  chartOptions: Partial<ChartOptions>;
  hasData: boolean = false;

  // Tabela
  pacientesList: any[] = [];
  page: number = 1;
  rows: number = 10;
  numberRows: number = 0;
  columns: any[] = [
    {
      keyColumn: 'paciente_nome',
      key: 'nomeCompleto',
      description: 'Nome do Paciente',
    },
    {
      keyColumn: 'total_medicoes',
      key: 'razao_social',
      description: 'Unidade de Sáude',
    },
    {
      keyColumn: 'ultima_medicao',
      key: 'municipio',
      description: 'Município',
    },
    {
      keyColumn: 'action',
      key: { view: true, edit: false, delete: false },
      description: 'Ações',
    },
  ];
    screen: string = 'relátorio-medição'
  constructor(
    private formBuilder: FormBuilder,
    private municipalityService: MunicipalityService,
    private healthUnitService: HealthUnitService,
    private medicaoService: MeasureService,
    private contextService: ContextService,
    private snackbar: SnackbarCustomService
  ) {
    this.chartOptions = this.initializeChart();
  }
  bairrosList: string[] = []

  ngOnInit() {
    this.createForm();
    this.getMunicipio();
    this.loadChartData();
    this.getContextos()
  }

  editItem(item: any){
    this.loading = true;
    const filters = this.buildFilters();
    filters.paciente_id = item.paciente_id
    this.medicaoService.getRelatorio(filters).subscribe({
      next: (response: any) => {
        this.processChartData(response.data);
        this.loading = false;
      },
      error: (err: any) => {
        console.error(err);
        this.loading = false;
      }
    });
  }

  deleteItem(item: any){
    console.log(item)
  }

  getContextos() {
    this.contextService.listContext().subscribe({
      next: (response: ResponseRequestModel) => {
        if(response.data) {
          this.contextosList = response.data
        }
      }, error: (err: ResponseRequestModel) => {
        console.error(err)
      }, complete: () => {},
    })
  }

  bairroInput!: FormControl;

// 3. Ajuste o método addBairro
  addBairro() {
    const value = this.bairroInput.value?.trim();

    if (!value) return;

    if (this.bairrosList.includes(value)) {
      this.snackbar.error('Este bairro já foi adicionado.');
      return;
    }

    this.bairrosList.push(value);
    this.bairroInput.reset();

    this.loadChartData();
  }


  removeBairro(index: number) {
    this.bairrosList.splice(index, 1);
    this.loadChartData();
  }
  get visibleBairros() {
    return this.bairrosList.slice(0, 3);
  }

  get hiddenBairrosCount() {
    return Math.max(0, this.bairrosList.length - 3);
  }
  createForm(): void {
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

    this.form = this.formBuilder.group({
      municipio: [null],
      unidadeSaude: [{ value: null, disabled: true }],
      contexto: [null],
      dataInicio: [firstDayOfMonth],
      dataFim: [today]
    });
    this.bairroInput = new FormControl('');

  }

  initializeChart(): Partial<ChartOptions> {
    return {
      series: [],
      chart: {
        height: 450,
        type: 'line',
        zoom: {
          enabled: true
        },
        toolbar: {
          show: true
        }
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: 'smooth',
        width: 3
      },
      title: {
        text: 'Histórico de Medições Glicêmicas',
        align: 'left',
        style: {
          fontSize: '18px',
          fontWeight: 'bold'
        }
      },
      grid: {
        row: {
          colors: ['#f3f3f3', 'transparent'],
          opacity: 0.5
        }
      },
      xaxis: {
        type: 'datetime',
        labels: {
          datetimeFormatter: {
            year: 'yyyy',
            month: "MMM 'yy",
            day: 'dd MMM',
            hour: 'HH:mm'
          },
          datetimeUTC: false
        }
      },
      yaxis: {
        title: {
          text: 'Média - Glicemia (mg/dL)'
        },
        min: 0
      },
      tooltip: {
        x: {
          formatter: (value: number) => {
            const date = new Date(value);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            return `${day}/${month}/${year} ${hours}:${minutes}`;
          }
        },
        y: {
          formatter: function(val) {
            return val + ' mg/dL';
          }
        }
      },
      markers: {
        size: 5,
        hover: {
          size: 7
        }
      },
      legend: {
        position: 'top',
        horizontalAlign: 'center'
      },
      colors: ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0']
    };
  }

  // Método helper para converter data/hora corretamente (NOVO)
  private parseDateTime(dataMedicao: string, horaMedicao: string): number {
    const [ano, mes, dia] = dataMedicao.split('-').map(Number);
    const [hora, minuto, segundo] = horaMedicao.split(':').map(Number);
    const date = new Date(ano, mes - 1, dia, hora, minuto, segundo || 0);
    return date.getTime();
  }

  getMunicipio() {
    this.municipalityService.listActiveMunicipality().subscribe({
      next: (response: any) => {
        if (response.data) {
          this.municipiosList = response.data;
        }
      },
      error: (err: ResponseRequestModel) => {
        console.error(err);
      }
    });
  }

  getUnidadesDeSaude(municipioId: number) {
    if (!municipioId) {
      this.unidadeSaudeList = [];
      return;
    }
    this.healthUnitService.listActiveLocationByMunicip(municipioId).subscribe({
      next: (response: ResponseRequestModel) => {
        this.unidadeSaudeList = response.data;
      },
      error: (err: ResponseRequestModel) => {
        console.error(err);
      }
    });
  }

  onMunicipioChange() {
    const municipioId = this.form.get('municipio')?.value;
    this.form.get('unidadeSaude')?.reset();

    if (municipioId) {
      this.isSelectHealthUnitActive = true;
      this.form.get('unidadeSaude')?.enable();
      this.getUnidadesDeSaude(municipioId);
    } else {
      this.isSelectHealthUnitActive = false;
      this.form.get('unidadeSaude')?.disable();
    }

    this.loadChartData();
  }

  onUnidadeSaudeChange() {
    this.loadChartData();
  }

  onContextoChange() {
    this.loadChartData();
  }

  onDateChange() {
    this.loadChartData();
  }

  loadChartData() {
    this.loading = true;
    this.medicaoService.getRelatorio(this.buildFilters()).subscribe({
      next: (response: any) => {
        this.processChartData(response.data);
      },
      error: (err: any) => {
        console.error(err);
        this.loading = false;
      }, complete: ()=> {
        this.loadPatients()
        this.loading = false;
      }
    });

  }

  buildFilters(): any {
    const formValues = this.form.value;
    const filters: any = {};

    if (formValues.municipio) {
      filters.municipio_id = formValues.municipio;
    }
    if (formValues.unidadeSaude) {
      filters.unidade_saude_id = formValues.unidadeSaude;
    }
    if (formValues.contexto) {
      filters.contexto_id = formValues.contexto;
    }
    if (formValues.dataInicio) {
      filters.data_inicio = this.formatDate(formValues.dataInicio);
    }
    if (formValues.dataFim) {
      filters.data_fim = this.formatDate(formValues.dataFim);
    }
    console.log(this.bairrosList)
    if(this.bairrosList.length>0){
      filters.bairros = [...this.bairrosList]
    }

    return filters;
  }

  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  processChartData(data: any[]) {
    if (!data || data.length === 0) {
      this.hasData = false;
      this.chartOptions.series = [];
      return;
    }

    this.hasData = true;

    const groupedByContext = data.reduce((acc, item) => {
      if (!acc[item.contexto]) acc[item.contexto] = [];
      acc[item.contexto].push(item);
      return acc;
    }, {} as Record<string, any[]>);

    const series: ApexAxisChartSeries = Object.keys(groupedByContext).map(contexto => {
      const contextoData = groupedByContext[contexto];

      const sortedData = contextoData.sort((a: any, b: any) => {
        // CORRIGIDO: Usar parseDateTime ao invés de new Date
        const dateA = this.parseDateTime(a.data_medicao, a.hora_medicao);
        const dateB = this.parseDateTime(b.data_medicao, b.hora_medicao);
        return dateA - dateB;
      });

      return {
        name: contexto,
        data: sortedData.map((item: any) => ({
          // CORRIGIDO: Usar parseDateTime ao invés de new Date
          x: this.parseDateTime(item.data_medicao, item.hora_medicao),
          y: parseFloat(item.media_valor),
          razao_social: item.razao_social ?? 'Não informado'
        }))
      };
    });

    this.chartOptions = {
      ...this.chartOptions,
      series
    };
  }

  loadPatients(){
    const filters = this.buildFilters();

    let filtrosFormatted: string;

    const chaves = Object.keys(filters);

    filtrosFormatted = chaves
      .map(key => `${key}=${filters[key]}`)
      .join('&');

    this.medicaoService.getPacientes(filtrosFormatted).subscribe({
      next: (response: ResponseRequestModel) => {
        if(response.data){
          this.pacientesList = response.data
          this.numberRows = this.pacientesList.length;
        }
      },
      error: (err: any) => {
        console.error(err);
      }, complete: ()=> {
    this.loading = false;
    }
    });
  }

  groupByPatient(data: MedicaoData[]): { [key: string]: MedicaoData[] } {
    return data.reduce((acc, item) => {
      if (!acc[item.paciente_id]) {
        acc[item.paciente_id] = [];
      }
      acc[item.paciente_id].push(item);
      return acc;
    }, {} as { [key: string]: MedicaoData[] });
  }

  processTableData(groupedByPatient: { [key: string]: MedicaoData[] }) {
    this.pacientesList = Object.keys(groupedByPatient).map(pacienteId => {
      const medicoes = groupedByPatient[pacienteId];

      const sortedMedicoes = medicoes.sort((a, b) => {
        const dateA = new Date(`${a.data_medicao}T${a.hora_medicao}`).getTime();
        const dateB = new Date(`${b.data_medicao}T${b.hora_medicao}`).getTime();
        return dateB - dateA;
      });

      const ultimaMedicao = sortedMedicoes[0];

      const somaValores = medicoes.reduce((sum, m) => sum + parseFloat(m.valor), 0);
      const media = somaValores / medicoes.length;

      return {
        paciente_id: pacienteId,
        paciente_nome: ultimaMedicao.paciente_nome,
        total_medicoes: medicoes.length,
        ultima_medicao: this.formatDateTime(ultimaMedicao.data_medicao, ultimaMedicao.hora_medicao),
        media_glicemia: media.toFixed(2),
        unidade_saude: ultimaMedicao.unidade_saude,
        municipio: ultimaMedicao.municipio
      };
    });

    this.numberRows = this.pacientesList.length;
  }

  formatDateTime(data: string, hora: string): string {
    const [ano, mes, dia] = data.split('-');
    const [h, m] = hora.split(':');
    return `${dia}/${mes}/${ano} ${h}:${m}`;
  }

  pageChanged(page: number) {
    this.page = page;
    this.loadChartData();
  }

  onPageEvent(event: any) {
    this.page = event.pageIndex + 1;
    this.rows = event.pageSize;
  }

  pageSizeChanged(newPageSize: number) {
    this.rows = newPageSize;
    this.page = 1;
    this.loadChartData();
  }

  clearFilters() {
    this.form.reset({
      municipio: null,
      unidadeSaude: null,
      contexto: null,
      dataInicio: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      dataFim: new Date()
    });
    this.bairrosList = []; // Adicione esta linha
    this.bairroInput.reset(); // Adicione esta linha
    this.isSelectHealthUnitActive = false;
    this.form.get('unidadeSaude')?.disable();
    this.loadChartData();
  }
}
